module.exports = __webpack_public_path__ + "static/img/next-big-future.3eb4796.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/next-big-future.png
// module id = SS88
// module chunks = 0